import Splide from '@splidejs/splide';

// Categories Grid
(() => {
  const categoryGrid = document.querySelector('.category-section-2');
  if (!categoryGrid) return;

  categoryGrid.querySelectorAll('.quicklinks > ul > li > a').forEach((item) => {
    item.nextElementSibling.append(item.cloneNode(true));
  });
})();

(() => {
  const categorySource = document.querySelector('.category-section-2');
  if (!categorySource) return;

  const slider = document.createElement('div');
  slider.classList.add('category-section-2__slider', 'splide');
  categorySource.appendChild(slider);
  const sliderTrack = document.createElement('div');
  sliderTrack.classList.add('splide__track');
  slider.appendChild(sliderTrack);
  const sliderList = document.createElement('div');
  sliderList.classList.add('splide__list');
  sliderTrack.appendChild(sliderList);

  const isNoSublinks = categorySource.classList.contains('no-sublinks');

  const categories = categorySource.querySelectorAll('.hasSubmenus > li');
  categories.forEach((category) => {
    const sliderSlide = document.createElement('div');
    sliderSlide.classList.add('splide__slide');
    sliderSlide.innerHTML = category.innerHTML;

    // Restructure: wrap direct anchor, ul.submenu, and "Request Info" link in a new div
    // Keep li.cat-bg-img outside the wrapper
    // Find direct child anchor (first anchor that's a direct child)
    const directAnchor = Array.from(sliderSlide.children).find((child) => child.tagName === 'A');
    const submenu = sliderSlide.querySelector('ul.submenu');
    // Find "Request Info" link - it's the anchor that's a direct child of ul
    const shopNowLink = submenu ? Array.from(submenu.children).find((child) => child.tagName === 'A') : null;
    // Find bgImgLi inside submenu (before we remove it)
    const bgImgLi = submenu ? submenu.querySelector('li.cat-bg-img') : null;

    if (directAnchor || submenu) {
      // Get the category href from directAnchor or shopNowLink
      const categoryHref = directAnchor?.getAttribute('href') || shopNowLink?.getAttribute('href');

      // If no-sublinks, create wrapper as an anchor; otherwise, a div
      let wrapper;
      if (isNoSublinks && categoryHref) {
        wrapper = document.createElement('a');
        wrapper.setAttribute('href', categoryHref);
      if (categoryHref) {
        wrapper.setAttribute('target', '_blank');
        wrapper.setAttribute('rel', 'noopener');
      }
      } else {
        wrapper = document.createElement('div');
      }
      wrapper.classList.add('category-content-wrapper');
      

      // Move direct anchor into wrapper (or convert to h3 if no-sublinks)
      if (directAnchor) {
        if (isNoSublinks && categoryHref) {
          // Convert anchor to h3 and remove original anchor
          const heading = document.createElement('h3');
          heading.innerHTML = directAnchor.innerHTML;
          heading.className = directAnchor.className;
          wrapper.appendChild(heading);
          directAnchor.remove();
        } else {
          wrapper.appendChild(directAnchor);
        }
      }

      // Process submenu: remove cat-bg-img and extract Request Info link
      if (submenu) {
        // Extract cat-bg-img from submenu (keep reference, will append later)
        if (bgImgLi) {
          bgImgLi.remove();
        }

        // Extract Request Info link from submenu (it's the anchor at the end of ul)
        if (shopNowLink) {
          shopNowLink.remove();
        }

        // Move modified submenu into wrapper
        wrapper.appendChild(submenu);

        // Add Request Info link to wrapper at the end (convert to span if no-sublinks)
        if (shopNowLink) {
          if (isNoSublinks && categoryHref) {
            const shopNowSpan = document.createElement('span');
            shopNowSpan.innerHTML = shopNowLink.innerHTML;
            shopNowSpan.className = shopNowLink.className;
            shopNowSpan.classList.add('shop-now-btn');
            wrapper.appendChild(shopNowSpan);
          } else {
            wrapper.appendChild(shopNowLink);
          }
        }
      }

      // Append wrapper to sliderSlide
      sliderSlide.appendChild(wrapper);

      // Append bgImgLi after wrapper (outside the wrapper)
      if (bgImgLi) {
        sliderSlide.appendChild(bgImgLi);
      }
    }

    sliderList.appendChild(sliderSlide);
  });

  categorySource.querySelector('.quicklinks').insertAdjacentElement('beforeend', slider);

  const splide = new Splide(slider, {
    type: 'slider',
    perPage: 5,
    perMove: 1,
    height: 330,
    gap: 10,
    pagination: false,
    arrows: false,
    drag: false,
    breakpoints: {
      1200: {
        perPage: 4,
        drag: true,
        arrows: true,
      },
      991: {
        perPage: 3,
        gap: 15,
      },
      600: {
        perPage: 2,
        gap: 10,
      },
      480: {
        perPage: 1,
      },
    },
  });
  splide.mount();
})();
